module.exports = __webpack_public_path__ + "img/MDI-alert-circle-outline.10f67b06.svg";